import { formatInTimeZone } from 'date-fns-tz';

export const ROUTE_SALESFORCE_COLUMNS = [
    {
        header: 'appointment_number',
        getValue: ({ orders }) =>
            (orders?.[0]?.references || []).find((ref) => ref.key === 'appointment_number')?.value || '',
    },
    {
        header: 'delivery_date',
        getValue: ({ opt }) => opt?.scheduledStart,
        format: (value, { tz = 'America/New_York' }) => formatInTimeZone(value, tz, 'yyyy-MM-dd'),
    },
    {
        // Always empty
        header: 'move_reason',
        getValue: () => '',
    },
    {
        header: 'assigned_service_resource',
        getValue: ({ route }) => {
            return route.resource?.name || '';
        },
    },
    {
        header: 'scheduled_start',
        getValue: ({ opt }) => opt?.scheduledStart,
        format: (value, { tz = 'America/New_York' }) => formatInTimeZone(value, tz, "yyyy-MM-dd'T'HH:mm"),
    },
    {
        header: 'scheduled_end',
        getValue: ({ opt }) => opt?.scheduledEnd,
        format: (value, { tz = 'America/New_York' }) => formatInTimeZone(value, tz, "yyyy-MM-dd'T'HH:mm"),
    },
    {
        // Always empty
        header: 'delivery_contact_status',
        getValue: () => '',
    },
    {
        header: 'stop',
        getValue: ({ opt }) => opt?.stopSequence,
    },
];
